import React from "react";
import { Route, Switch } from "react-router-dom";

import EditStation from "../screens/EditStation";
import Credentials from "../screens/Credentials";
import ViewStation from "../screens/ViewStation";
import AddStation from "../screens/AddStation";
import CreateUser from "../screens/CreateUser"
import LoadsList from "../screens/LoadsList";
import Stations from "../screens/StationsList";
import Pivote from "../screens/Pivote";
import Users from "../screens/UsersList";
import Home from "../screens/Home";

const Routes = () =>
    <Switch>
        <Route exact path={"/"} render={(props) => <Home {...props}/> }/>
        <Route path={"/addStation"} render={(props) => <AddStation {...props}/> }/>
        <Route path={"/editStation"} render={(props) => <EditStation {...props}/> }/>
        <Route path={"/viewStation"} render={(props) => <ViewStation {...props}/>} />
        <Route path={"/stations"} render={(props) => <Stations {...props}/>} />
        <Route path={"/loads"} render={(props) => <LoadsList {...props}/>} />
        <Route path={"/users"} render={(props) => <Users {...props}/>} />
        <Route path={"/addUser"} render={(props) => <CreateUser {...props}/>} />
        <Route path={"/credentials"} render={(props) => <Credentials {...props}/>} />
        <Route path={"/pivote"} render={(props) => <Pivote {...props} />} />
    </Switch>

export default Routes;